var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDigitalGiftCardinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M18 7h5M5 11h30m1 42v4.26c0 2 0 2.74-2 2.74H7q-2-.557-2-2V6c0-1.443.643-2 2-2h27c1.357 0 2 .557 2 2v14"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(14 20)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 33,
  strokeLinecap: "square",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "m13 21 5.21-5M23 21l-5-5m0-6.213L9 7v10.5l9-2.5zm0 0L27 7v10.421L18 15z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M1.086 12H8.9M18 .868V33m9.79-21h16.5"
})))));
export default SvgDigitalGiftCardinline;